import { render, staticRenderFns } from "./Paperless.vue?vue&type=template&id=862b4290"
import script from "./Paperless.vue?vue&type=script&lang=js"
export * from "./Paperless.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports